import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import {
    MOTION_CSS_EASINGS
} from "../../../../helpers/motion";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    webBlink: webStyle({
        animationTimingFunction: MOTION_CSS_EASINGS.inOut,
        animationIterationCount: "infinite",
        animationKeyframes: {
            "0%, 100%": {
                opacity: 1
            },
            "50%": {
                opacity: 0
            }
        }
    }),
    container: {
    }
});

export const useStyles = ({
    blinkDuration,
    lineHeight,
    borders,
    spaces,
    color
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
    borders: NCoreUIKit.Borders;
    blinkDuration: number;
    lineHeight: number;
    color: string;
}) => {
    const styles = {
        webBlink: webStyle({
            animationDuration: `${blinkDuration}ms`
        }) as Mutable<ViewStyle>,
        container: {
            marginStart: spaces.spacingXxs,
            backgroundColor: color,
            width: borders.focus,
            height: lineHeight
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
